module.exports = __webpack_public_path__ + "media/images/buriel-1-4f6cfe7848bccea61b720468fc0a0dee.png";